
import { Component, Prop, Vue } from "vue-property-decorator";

interface SortInterface<Key = string> {
  key: Key;
  direction?: "asc" | "desc";
}

@Component({
  name: "alert-history-list",
})
export default class AlertHistoryList extends Vue {
  @Prop({ required: false, type: String, default: "de" })
  private readonly locale!: string;

  @Prop({
    required: false,
    type: Object,
    default: (): SortInterface => ({ key: "dateTime", direction: "asc" }),
  })
  private readonly defaultSort!: SortInterface;

  @Prop({ required: false, type: Number, default: 10 })
  private readonly itemsPerPage!: number;

  public onTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("alert-history-list-row-clicked", { detail: payload })
    );
  }
  public onTableRowKeyClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("alert-history-list-row-key-clicked", { detail: payload })
    );
  }
}
